export function resolveTargetClientId(
  _userId: string,
  authorizedIds: string[],
  currentUrlIds?: string | string[]
): string | null {
  if (authorizedIds.length === 0) return null;

  const currentUrlId = Array.isArray(currentUrlIds) ? currentUrlIds[0] : currentUrlIds;

  if (currentUrlId) {
    if (authorizedIds.includes(currentUrlId)) {
      return currentUrlId;
    }
  }

  return authorizedIds[0];
}

export function isAuthorizedClientId(
  id: string | undefined,
  user: any | null | undefined,
  clientList: any | null | undefined
): boolean {
  if (!id) return false;

  if (!isClientIdFormat(id)) {
    return false;
  }

  const isInUserMetadata = user?.client_ids?.includes(id);
  const isInClientList = clientList?.data?.some((c: any) => c.id === id);

  return !!(isInUserMetadata || isInClientList);
}

export function isClientIdFormat(id: string | undefined): boolean {
  if (!id) return false;
  const numericPart = id.replace(/^(cli_|wor_)/, '');
  return /^\d+$/.test(numericPart) && numericPart.length >= 15;
}
